// @core/api/endpoints/notifications/delete_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/notifications';

/**
 * Delete notification template
 * Permanently deletes a notification template. Templates currently in use should be replaced before deletion.
 */
export async function DeleteTemplate(
  template_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/templates/:template_id`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
